import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const SuggestionsForSchoolImprovementBySMCMembers = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Suggestions for school improvement by SMC members" />
    </Box>
  );
};
